import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/admin/index.vue";
import AdminCourseLayout from "../layout/admin/CourseIndex.vue";
import qualityCourseLayout from "../layout/qualityCourse/index.vue";
import layoutContent from "../layout/student/LayoutContent";
import homeLayout from "../layout/qualityCourse/home.vue";
import loginLayout from "../layout/qualityCourse/login";
import newsLayout from "../views/admin/NewsManage";
import studentProjectLayout from "../layout/student/studentProjectLayout";
import CourseLayout from "../views/admin/Course";
import TeacherCourseLayout from "../views/admin/TeacherCourseLayout.vue";
import studentCourseLayout from "../views/student/Course.vue";
import Router from "vue-router";
import { teachRoutes } from "@/router/teach";
import config from "@/config/config";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
    {
        path: "/demo/upload",
        component: () => import("../views/WsUploadComponent.vue"),
        meta: {
            title: "测试ws上传文件",
        },
    },
    {
        path: "/teacher",
        redirect: "/user/teacherLogin",
    },
    {
        path: "/admin/index",
        redirect: "/admin/index",
        component: Layout,
        children: [
            {
                path: "/admin/index",
                name: "adminIndex",
                component: () => import("../views/admin/Index.vue"),
                meta: {
                    title: "素材中心",
                },
            },
            {
                path: "/admin/index/addSubject",
                name: "addSubject",
                component: () => import("../components/material/MaterialExamSubjectAdd.vue"),
                meta: {
                    title: "添加试题",
                },
            },
            {
                path: "/admin/index/editSubject",
                name: "editSubject",
                component: () => import("../components/material/MaterialExamSubjectEdit.vue"),
                meta: {
                    title: "编辑试题",
                },
            },
            {
                path: "/admin/index/examPaper",
                name: "addExamPaper",
                component: () => import("../components/material/examPaper/addExamPaper.vue"),
                meta: {
                    title: "素材中心-添加试卷",
                },
            },
            {
                path: "/admin/index/addProject",
                name: "addProject",
                component: () => import("../components/material/MaterialProjectAdd.vue"),
                meta: {
                    title: "新建项目",
                },
            },
            {
                path: "/admin/index/projectDetail",
                name: "projectDetail",
                component: () => import("../components/material/MaterialProjectDetail"),
                meta: {
                    title: "项目详情",
                },
            },
        ],
    },
    {
        path: "/admin/classManage",
        component: Layout,
        children: [
            {
                path: "/admin/classManage/index",
                name: "adminClassManage",
                component: () => import("../views/admin/ClassManage.vue"),
                meta: {
                    title: "分类管理",
                },
            },
        ],
    },
    {
        path: "/admin/courseManage",
        component: Layout,
        children: [
            {
                path: "/admin/courseManage/index",
                name: "adminCourseManage",
                component: () => import("../views/admin/CourseManage.vue"),
                meta: {
                    title: "课程管理",
                },
            },
        ],
    },
    {
        path: "/admin/courseIndexAdd",
        component: AdminCourseLayout,
        children: [
            {
                path: "/admin/courseIndexAdd/index",
                name: "adminCourseIndexAdd",
                component: () => import("../views/admin/CourseIndexAdd.vue"),
                meta: {
                    title: "课程编辑",
                },
            },
        ],
    },
    {
        path: "/admin/educationManage",
        component: Layout,
        children: [
            {
                path: "/admin/educationManage/index",
                name: "adminEducationManage",
                component: () => import("../views/admin/EducationManage.vue"),
                meta: {
                    title: "教务管理",
                },
            },
        ],
    },
    {
        path: "/admin/course",
        component: Layout,
        children: [
            {
                path: "/admin/course/featured",
                name: "adminCourse",
                component: CourseLayout,
                children: [
                    {
                        path: "/admin/course/courseindex",
                        name: "adminCourseIndex",
                        component: () => import("../components/schoolAdministrator/course/CourseIndex.vue"),
                        meta: {
                            title: "课程-首页",
                            tabName: "adminCourseIndex",
                        },
                    },
                    {
                        path: "/admin/course/featured",
                        name: "adminFeatured",
                        component: () => import("../components/schoolAdministrator/course/Featured.vue"),
                        meta: {
                            title: "课程-精选",
                            tabName: "adminFeatured",
                        },
                    },
                    {
                        path: "/admin/course/CourseWareDetail",
                        name: "adminCourseWareDetail",
                        component: () => import("../components/schoolAdministrator/course/CourseWareDetail.vue"),
                        meta: {
                            title: "课程-精选课程",
                            tabName: "adminCourseWareDetail",
                        },
                    },
                    {
                        path: "/admin/course/featureddetail",
                        name: "adminFeaturedDetail",
                        component: () => import("../components/schoolAdministrator/course/FeaturedDetail.vue"),
                        meta: {
                            title: "课程-精选课程",
                            tabName: "adminFeatured",
                        },
                    },
                    {
                        path: "/admin/course/MatingDetail",
                        name: "adminteacherMatingDetail",
                        component: () => import("../components/schoolAdministrator/course/MatingDetail.vue"),
                        meta: {
                            title: "课程--配套材料",
                            tabName: "adminFeatured",
                        },
                    },
                    {
                        path: "/admin/course/materialslist",
                        name: "adminMaterialsList",
                        component: () => import("../components/schoolAdministrator/course/MaterialsList.vue"),
                        meta: {
                            title: "课程--配套材料",
                            tabName: "adminFeatured",
                        },
                    },
                    {
                        path: "/admin/course/courseware",
                        name: "adminCourseWare",
                        component: () => import("../components/schoolAdministrator/course/CourseWare.vue"),
                        meta: {
                            title: "课程-课件",
                            tabName: "adminCourseWare",
                        },
                    },
                    {
                        path: "/admin/course/textbook",
                        name: "adminTextbook",
                        component: () => import("../components/schoolAdministrator/course/Textbook.vue"),
                        meta: {
                            title: "课程-教材",
                            tabName: "adminTextbook",
                        },
                    },
                    {
                        path: "/admin/course/microlesson",
                        name: "adminMicroLesson",
                        component: () => import("../components/schoolAdministrator/course/MicroLesson.vue"),
                        meta: {
                            title: "课程-微课",
                            tabName: "adminMicroLesson",
                        },
                    },
                    {
                        path: "/admin/course/animation",
                        name: "adminAnimation",
                        component: () => import("../components/schoolAdministrator/course/Animation.vue"),
                        meta: {
                            title: "课程-动画",
                            tabName: "adminAnimation",
                        },
                    },
                ],
            },
            {
                path: "/admin/course/courseDetail",
                name: "schoolAdminCourseDetail",
                component: () => import("../components/teacherCourse/TeacherCourseDetail.vue"),
                meta: {
                    title: "课程-详情页",
                    // tabName:'teacherCourseIndex'
                },
            },
        ],
    },
    {
        path: "/admin/newsManage",
        component: Layout,
        children: [
            {
                path: "/admin/newsManage/index",
                name: "adminNewsManage",
                component: newsLayout,
                children: [
                    {
                        path: "/admin/newsManage/index",
                        name: "adminNewsManageIndex",
                        component: () => import("../views/admin/NewsIndex"),
                        meta: {
                            title: "新闻管理",
                        },
                    },
                    {
                        path: "/admin/newsManage/add",
                        name: "adminNewsAdd",
                        component: () => import("../views/admin/NewsAdd"),
                        meta: {
                            title: "新闻管理",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/admin/carouselManage",
        component: Layout,
        children: [
            {
                path: "/admin/carouselManage/index",
                name: "adminCarouselManage",
                component: () => import("../views/admin/CarouselManage"),
                meta: {
                    title: "轮播管理",
                },
            },
        ],
    },
    {
        path: "/admin/applicationCenter",
        component: Layout,
        children: [
            {
                path: "/admin/applicationCenter/index",
                name: "adminApplicationCenter",
                component: () => import("../views/admin/applicationCenter"),
                meta: {
                    title: "应用中心",
                },
            },
        ],
    },
    {
        path: "/admin/projectLibrary",
        component: Layout,
        children: [
            {
                path: "/admin/projectLibrary/index",
                name: "adminProjectLibrary",
                component: () => import("../views/admin/projectLibrary"),
                meta: {
                    title: "项目库",
                },
            },
            {
                path: "/admin/projectLibrary/project",
                name: "adminProject",
                component: () => import("../views/admin/Project"),
                meta: {
                    title: "项目库",
                },
            },
        ],
    },
    {
        path: "/admin/courseManage/qualityCourseCreate",
        name: "adminCourseManageQualityCourseCreate",
        component: () => import("../components/createCourse/QualityCourseCreate.vue"),
        meta: {
            title: "创建精品课程",
        },
    },
    {
        path: "/admin",
        redirect: "/admin/login",
    },
    {
        path: "/admin/login",
        name: "adminLogin",
        component: () => import("../views/admin/Login.vue"),
        meta: {
            title: "资源管理--欢迎登录",
        },
    },
    // {
    //     path: '/course',
    //     component: qualityCourseLayout,
    //     children: [{
    //         path: '/course/courseIndex',
    //         name: 'courseIndex',
    //         component: () => import('../views/qualityCourse/courseIndex.vue'),
    //         meta: {
    //             title: '课程'
    //         }
    //     }]
    // },
    {
        path: "/course/courseIndex",
        name: "courseIndex",
        component: () => import("../views/qualityCourse/courseIndex.vue"),
        meta: {
            title: "课程",
        },
    },
    {
        path: "/course/inClass",
        name: "courseIndex",
        component: () => import("../views/qualityCourse/InClass.vue"),
        meta: {
            title: "教师-课程-上课中",
        },
    },
    {
        path: "/course/PaperDetail",
        name: "coursePaperDetail",
        component: () => import("../views/qualityCourse/PaperDetail.vue"),
        meta: {
            title: `${config.quizName}详情`,
        },
    },
    {
        path: "/exampaper/preview",
        name: "exampaperPreview",
        component: () => import("../views/qualityCourse/examPaperPreView"),
        meta: {
            title: "试卷预览",
        },
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/PublicClass",
                name: "qualityCoursePublicClass",
                component: () => import("../components/qualityCourse/PublicClass.vue"),
                meta: {
                    title: "公开课",
                },
            },
        ],
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/projectclassify",
                name: "qualityCourseProjectIndex",
                component: studentProjectLayout,
                children: [
                    {
                        path: "/qualityCourse/projectclassify",
                        name: "qualityCourseProjectClassify",
                        component: () => import("../components/qualityCourse/ProjectClassify.vue"),
                        meta: {
                            title: "项目库分类",
                        },
                    },
                    {
                        path: "/qualityCourse/Project",
                        name: "qualityCourseProjectClassify",
                        component: () => import("../components/qualityCourse/Project.vue"),
                        meta: {
                            title: "项目库列表",
                        },
                    },
                    {
                        path: "/qualityCourse/project/detail",
                        name: "qualityCourseProjectClassify",
                        component: () => import("../components/qualityCourse/ProjectDetail.vue"),
                        meta: {
                            title: "项目详情",
                        },
                    }, {
                        path: "/qualityCourse/project/scoreBreakdown",
                        name: "qualityCourseProjectscoreBreakdown",
                        component: () => import("../components/qualityCourse/ScoreBreakdown.vue"),
                        meta: {
                            title: "得分明细",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/course/practical/detail",
        name: "coursePracticalDetail",
        component: () => import("../views/qualityCourse/PracticalDetail.vue"),
        meta: {
            title: "实训详情",
        },
    },
    {
    
        path: "/course/practical/scoreBreakdown",
        name: "coursePracticalScoreBreakdown",
        component: () => import("../components/qualityCourse/ScoreBreakdown.vue"),
        meta: {
            title: "得分明细",
        },
        
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/PublicClassDetail",
                name: "qualityCoursePublicClass",
                component: () => import("../components/qualityCourse/PublicClassDetail.vue"),
                meta: {
                    title: "公开课详情",
                },
            },
        ],
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/index",
                name: "qualityCourse",
                component: studentCourseLayout,
                children: [
                    {
                        path: "/qualityCourse/courseindex",
                        name: "qualityStudentCourse",
                        component: () => import("../components/Student/course/CourseIndex.vue"),
                        meta: {
                            title: "课程-首页",
                            tabName: "studentCourseIndex",
                        },
                    },
                    {
                        path: "/qualityCourse/featured",
                        name: "qualityStudentCourse",
                        component: () => import("../components/Student/course/Featured.vue"),
                        children: [
                            {
                                path: "/qualityCourse/featureddetail",
                                name: "qualityStudentCourse",
                                component: () => import("../components/Student/course/FeaturedDetail.vue"),
                                meta: {
                                    title: "课程-精选-配套材料",
                                    tabName: "studentFeaturedDetail",
                                },
                            },
                            {
                                path: "/qualityCourse/literacy",
                                name: "studentLiteracy",
                                component: () => import("../components/Student/course/LiteracyAssment.vue"),
                                meta: {
                                    title: "素养评价",
                                    tabName: "studentLiteracy",
                                },
                            },
                            {
                                path: "/qualityCourse/studentActivity",
                                name: "studentActivity",
                                component: () => import("../components/Student/course/studentActivity.vue"),
                                meta: {
                                    title: "教学活动",
                                    tabName: "studentActivity",
                                },
                                redirect: "/qualityCourse/ActivitiesOperate",
                                children: [
                                    {
                                        path: "/qualityCourse/ActivitiesOperate",
                                        name: "ActivitiesOperate",
                                        component: () => import("../components/Student/course/ActivitiesOperate.vue"),
                                        meta: {
                                            title: "教学活动页",
                                            tabName: "ActivitiesOperate",
                                        },
                                    },
                                    {
                                        path: "/qualityCourse/ActivityDetial",
                                        name: "ActivityDetial",
                                        component: () => import("../components/Student/course/ActivityDetial.vue"),
                                        meta: {
                                            title: "教学活动详情",
                                            tabName: "ActivityDetial",
                                        },
                                    },
                                ],
                            },
                            {
                                path: "/qualityCourse/leaderboard",
                                name: "studentLeaderboard",
                                component: () => import("../components/teacherCourse/leaderboard.vue"),
                                meta: {
                                    title: "排行榜",
                                    tabName: "studentLeaderboard",
                                },
                            },
                             
                          
                            {
                                path: "/student/qualityCourse/scoreBreakdown",
                                name: "studentScoreBreakdown",
                                component: () => import("../components/qualityCourse/ScoreBreakdown.vue"),
                                meta: {
                                    title: "得分明细",
                                    tabName: "studentLeaderboard",
                                }, 
                            }
                        ],
                        meta: {
                            title: "课程-精选",
                            tabName: "studentFeatured",
                        },
                    },
                    // {
                    //     path: '/qualityCourse/featureddetail',
                    //     name: 'studentFeaturedDetail',
                    //     component: () => import('../components/Student/course/FeaturedDetail.vue'),
                    //     meta: {
                    //         title: '课程-精选-配套材料',
                    //         tabName: 'studentFeaturedDetail'
                    //     }
                    // },
                    {
                        path: "/qualityCourse/courseware",
                        name: "studentCourseWare",
                        component: () => import("../components/Student/course/CourseWare.vue"),
                        meta: {
                            title: "课程-课件",
                            tabName: "studentCourseWare",
                        },
                    },
                    {
                        path: "/qualityCourse/textbook",
                        name: "studentTextbook",
                        component: () => import("../components/Student/course/Textbook.vue"),
                        meta: {
                            title: "课程-教材",
                            tabName: "studentTextbook",
                        },
                    },
                    {
                        path: "/qualityCourse/microlesson",
                        name: "studentMicroLesson",
                        component: () => import("../components/Student/course/MicroLesson.vue"),
                        meta: {
                            title: "课程-微课",
                            tabName: "studentMicroLesson",
                        },
                    },
                    {
                        path: "/qualityCourse/animation",
                        name: "studentAnimation",
                        component: () => import("../components/Student/course/Animation.vue"),
                        meta: {
                            title: "课程-动画",
                            tabName: "studentAnimation",
                        },
                    },
                ],
            },
            {
                path: "/qualityCourse/courseDetail",
                name: "qualityCourseDetail",
                component: () => import("../components/teacherCourse/TeacherCourseDetail.vue"),
                meta: {
                    title: "课程-详情页",
                    // tabName:'teacherCourseIndex'
                },
            },

            {
                path: "/qualityCourse/teacher/teacherFeatured",
                name: "teacherCourse",
                component: TeacherCourseLayout,
                children: [
                    {
                        path: "/qualityCourse/teacher/index",
                        name: "teacherCourseIndex",
                        component: () => import("../components/teacherCourse/teacherIndex.vue"),
                        meta: {
                            title: "课程-首页",
                            tabName: "teacherCourseIndex",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/weightSetting",
                        name: "weightSetting",
                        component: () => import("../components/teacherCourse/weightSetting.vue"),
                        meta: {
                            title: "权重设置",
                            tabName: "teacherWeightSetting",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/teacherFeatured",
                        // name: 'teacherFeatured',
                        name: "qualityCourse",
                        component: () => import("../components/teacherCourse/teacherFeatured.vue"),
                        children: [
                            {
                                path: "/qualityCourse/teacher/teacherCourseWareDetail",
                                // name: 'teacherCourseWareDetail',
                                name: "qualityCourse",
                                component: () => import("../components/teacherCourse/teacherCourseWareDetail.vue"),
                                meta: {
                                    title: "精选课程",
                                    tabName: "teacherCourseIndex",
                                },
                            },
                            {
                                path: "/qualityCourse/teacher/teacherMatingDetail",
                                // name: 'teacherMatingDetail',
                                name: "qualityCourse",
                                component: () => import("../components/teacherCourse/teacherMatingDetail.vue"),
                                meta: {
                                    title: "配套材料",
                                    tabName: "teacherCourseIndex",
                                },
                            },
                            {
                                path: "/qualityCourse/teacher/preparelessons",
                                // name: 'preparelessons',
                                name: "qualityCourse",
                                component: () => import("../components/teacherCourse/preparelessons.vue"),
                                meta: {
                                    title: "备课",
                                    tabName: "preparelessonsIndex",
                                },
                            },
                            {
                                path: "/qualityCourse/teacher/literacyEvaluation",
                                name: "literacyEvaluation",
                                component: () => import("../components/teacherCourse/literacyEvaluation.vue"),
                                redirect: "/qualityCourse/teacher/literacyEvaluationView",
                                meta: {
                                    title: "素养评价",
                                    tabName: "literacyEvaluation",
                                },
                                children: [
                                    {
                                        path: "/qualityCourse/teacher/literacyEvaluationView",
                                        name: "literacyEvaluationView",
                                        component: () => import("../components/teacherCourse/literacyEvaluationView.vue"),
                                        meta: {
                                            title: "素养评价",
                                            tabName: "literacyEvaluation",
                                        },
                                    },
                                    {
                                        path: "/qualityCourse/teacher/studentLiteracyAssessment",
                                        name: "studentLiteracyAssessment",
                                        component: () => import("../components/teacherCourse/studentLiteracyAssessment.vue"),
                                        meta: {
                                            title: "学员素养评定",
                                            tabName: "studentLiteracyAssessment",
                                        },
                                    },
                                ],
                            },
                            {
                                path: "/qualityCourse/teacher/teachingActivity",
                                name: "qualityCourse",
                                component: () => import("../components/teacherCourse/teachingActivity.vue"),
                                redirect: "/qualityCourse/teacher/teachingActivitiesOperate",
                                meta: {
                                    title: "教学活动",
                                    tabName: "teachingActivity",
                                },
                                children: [
                                    {
                                        path: "/qualityCourse/teacher/teachingActivitiesOperate",
                                        name: "teachingActivitiesOperate",
                                        component: () => import("../components/teacherCourse/teachingActivitiesOperate.vue"),
                                        meta: {
                                            title: "教学活动页",
                                            tabName: "teachingActivity",
                                        },
                                    },
                                    {
                                        path: "/qualityCourse/teacher/teachingActivityDetial",
                                        name: "teachingActivityDetial",
                                        component: () => import("../components/teacherCourse/teachingActivityDetial.vue"),
                                        meta: {
                                            title: "活动详情",
                                            tabName: "teachingActivityDetial",
                                        },
                                    },
                                ],
                            },
                            {
                                path: "/qualityCourse/teacher/leaderboard",
                                name: "qualityCourse",
                                component: () => import("../components/teacherCourse/leaderboard.vue"),
                                meta: {
                                    title: "排行榜",
                                    tabName: "teachingActivity",
                                },
                            },
                            {
                                path: "/qualityCourse/leaderBoardDetial",
                                name: "studentLeaderBoardDetial",
                                component: () => import("../components/teacherCourse/LeaderBoardDetial.vue"),
                                meta: {
                                    title: "排行榜得分详情",
                                    tabName: "studentLeaderboardDetial",
                                },
                                children:[
                                    {
                                        path: "/qualityCourse/leaderBoardDetial/attidute",
                                        name: "studentLeaderBoardDetialAttidute",
                                        component: () => import("../components/teacherCourse/leaderBoard/DetialOfAttidute.vue"),
                                        meta: {
                                            title: "态度得分详情",
                                            tabName: "studentLeaderboardDetial",
                                        },
                                    }, 
                                    {
                                        path: "/qualityCourse/leaderBoardDetial/skill",
                                        name: "studentLeaderBoardDetialSkill",
                                        component: () => import("../components/teacherCourse/leaderBoard/DetialOfSkill.vue"),
                                        meta: {
                                            title: "技能得分详情",
                                            tabName: "studentLeaderboardDetial",
                                        },
                                    }, 
                                    {
                                        path: "/qualityCourse/leaderBoardDetial/knowledge",
                                        name: "studentLeaderBoardDetialAttiduteKnowledge",
                                        component: () => import("../components/teacherCourse/leaderBoard/DetialOfKnowledge.vue"),
                                        meta: {
                                            title: "知识得分详情",
                                            tabName: "studentLeaderboardDetial",
                                        },
                                    },  
                                    {
                                        path: "/qualityCourse/leaderBoardDetial/Literacy",
                                        name: "studentLeaderBoardDetialLiteracy",
                                        component: () => import("../components/teacherCourse/leaderBoard/DetialOfLiteracy.vue"),
                                        meta: {
                                            title: "素养得分详情",
                                            tabName: "studentLeaderboardDetial",
                                        },
                                    },
                                ]
                            },
                            {
                                path: "/qualityCourse/scoreBreakdown",
                                name: "ScoreBreakdown",
                                component: () => import("../components/qualityCourse/ScoreBreakdown.vue"),
                                meta: {
                                    title: "得分明细",
                                    tabName: "studentLeaderboard",
                                }, 
                            }
                            // literacyEvaluationView
                        ],
                        meta: {
                            title: "课程-精选",
                            tabName: "teacherFeatured",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/teacherCourseWare",
                        name: "teacherCourseWare",
                        component: () => import("../components/teacherCourse/teacherCourseWare.vue"),
                        meta: {
                            title: "课程-课件",
                            tabName: "teacherCourseWare",
                        },
                    },
                    // ,{
                    //     path: '/qualityCourse/teacher/teacherCourseWareDetail',
                    //     name: 'teacherCourseWareDetail',
                    //     component: () => import('../components/teacherCourse/teacherCourseWareDetail.vue'),
                    //     meta: {
                    //         title: '精选课程',
                    //         tabName: 'teacherCourseIndex'
                    //     }
                    // }
                    // ,
                    // {
                    //     path: '/qualityCourse/teacher/teacherMatingDetail',
                    //     name: 'teacherMatingDetail',
                    //     component: () => import('../components/teacherCourse/teacherMatingDetail.vue'),
                    //     meta: {
                    //         title: '配套材料',
                    //         tabName: 'teacherCourseIndex'
                    //     }
                    // }
                    {
                        path: "/qualityCourse/teacher/teacherTextbook",
                        name: "teacherTextbook",
                        component: () => import("../components/teacherCourse/teacherTextbook.vue"),
                        meta: {
                            title: "课程-教材",
                            tabName: "teacherTextbook",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/teacherMicroLesson",
                        name: "teacherMicroLesson",
                        component: () => import("../components/teacherCourse/teacherMicroLesson.vue"),
                        meta: {
                            title: "课程-微课",
                            tabName: "teacherMicroLesson",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/teacherAnimation",
                        name: "teacherAnimation",
                        component: () => import("../components/teacherCourse/teacherAnimation.vue"),
                        meta: {
                            title: "课程-动画",
                            tabName: "teacherAnimation",
                        },
                    },
                ],
            },
            {
                path: "/qualityCourse/teacher/courseDetail",
                name: "teacherCourseDetail",
                component: () => import("../components/teacherCourse/TeacherCourseDetail.vue"),
                meta: {
                    title: "课程-详情页",
                    // tabName:'teacherCourseIndex'
                },
            },
        ],
    },
    // {
    //   path: '/qualityCourse',
    //   component: qualityCourseLayout,
    //   children: [{
    //       path: '/qualityCourse/student/courseList',
    //       name: 'qualityStudentCourse',
    //       component: () => import('../components/Student/course/courseList.vue'),
    //       meta: {
    //           title: '课程列表'
    //       },
    //   },
    //   ]
    // },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/courseDetail",
                name: "qualityCourseDetail",
                component: () => import("../views/qualityCourse/CourseDetail.vue"),
                meta: {
                    title: "课程详情",
                },
            },
        ],
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/classRecord",
                name: "classRecord",
                component: () => import("../views/qualityCourse/classRecord.vue"),
                meta: {
                    title: "上课记录",
                },
            },
            {
                path: "/qualityCourse/recordDetail",
                name: "classRecord",
                component: () => import("../views/qualityCourse/recordDetail.vue"),
                meta: {
                    title: "上课记录详情",
                },
            },
            {
                path: "/qualityCourse/quizList",
                name: "classRecord",
                component: () => import("../views/qualityCourse/QuizList.vue"),
                meta: {
                    title: `${config.quizName}列表`,
                },
            },
            {
                path: "/qualityCourse/discussDetail",
                name: "classRecord",
                component: () => import("../views/qualityCourse/DiscussDetail.vue"),
                meta: {
                    title: "讨论详情",
                },
            },
            {
                path: "/qualityCourse/practicalList",
                name: "classRecord",
                component: () => import("../views/qualityCourse/practicalList.vue"),
                meta: {
                    title: "实训列表",
                },
            },
            {
                path: "/qualityCourse/quizApproved",
                name: "classRecord",
                component: () => import("../views/qualityCourse/QuizApproved.vue"),
                meta: {
                    title: "已批阅",
                },
            },
            {
                path: "/qualityCourse/quizUnApproved",
                name: "classRecord",
                component: () => import("../views/qualityCourse/QuizUnApproved.vue"),
                meta: {
                    title: "未批阅",
                },
            },
            {
                path: "/qualityCourse/quizUnCommitted",
                name: "classRecord",
                component: () => import("../views/qualityCourse/QuizUnCommitted.vue"),
                meta: {
                    title: "未提交",
                },
            },
            {
                path: "/qualityCourse/allApprovedDetail",
                name: "classRecord",
                component: () => import("../views/student/AllApprovedDetail.vue"),
                meta: {
                    title: "批阅详情",
                },
            },
            {
                path: "/qualityCourse/practicalDetail",
                name: "classRecord",
                component: () => import("../views/student/practicalDetail.vue"),
                meta: {
                    title: "实训详情",
                },
            },
            {
                path: "/qualityCourse/approvedDetail",
                name: "classRecord",
                component: () => import("../views/student/ApprovedDetail.vue"),
                meta: {
                    title: "问答题未批阅详情",
                },
            },
            {
                path: "/qualityCourse/ApprovedDetailShangke",
                name: "classRecord",
                component: () => import("../views/qualityCourse/ApprovedDetailShangke.vue"),
                meta: {
                    title: "问答题未批阅详情",
                },
            },
        ],
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/educational",
                name: "qualityEducational",
                component: () => import("../views/qualityCourse/educational.vue"),
                meta: {
                    title: "教务管理",
                },
            },
            {
                path: "/qualityCourse/createClass",
                name: "qualityCreateClass",
                component: () => import("../views/qualityCourse/createClass.vue"),
                meta: {
                    title: "创建班级",
                },
            },
        ],
    },
    {
        path: "/qualityCourse",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/courseList",
                name: "qualityCourse",
                component: () => import("../views/qualityCourse/courseList.vue"),
                meta: {
                    title: "课程列表",
                },
            },
        ],
    },
    {
        path: "/",
        component: homeLayout,
        children: [
            {
                path: "/",
                name: "home",
                component: () => import("../views/qualityCourse/Home.vue"),
                meta: {
                    title: "云平台",
                },
            },
            {
                path: "/qualityCourse/integrationCourse",
                name: "qualityCourseIntegrationCourse",
                component: () => import("../components/qualityCourse/integrationCourse.vue"),
                meta: {
                    title: "一体化课程",
                },
            },
            {
                path: "/qualityCourse/home/PublicClass",
                name: "qualityCourseHomePublicClass",
                component: () => import("../components/qualityCourse/PublicClass.vue"),
                meta: {
                    title: "公开课",
                },
            },
            {
                path: "/qualityCourse/home/PublicClassDetail",
                name: "qualityCourseHomePublicClassDetail",
                component: () => import("../components/qualityCourse/PublicClassDetail.vue"),
                meta: {
                    title: "公开课详情",
                },
            },
            {
                path: "/qualityCourse/contactUs",
                name: "qualityCourseContactUs",
                component: () => import("../components/qualityCourse/ContactUs"),
                meta: {
                    title: "联系我们",
                },
            },
            {
                path: "/qualityCourse/newsCenter",
                name: "qualityCourseNewsCenter",
                component: () => import("../components/qualityCourse/NewsCenter.vue"),
                meta: {
                    title: "新闻中心",
                },
            },
            {
                path: "/qualityCourse/newsCenterDetail",
                name: "qualityCourseNewsCenterDetail",
                component: () => import("../components/qualityCourse/NewsCenterDetail"),
                meta: {
                    title: "新闻详情",
                },
            },
            //这四个新闻详情页到时候要删掉
            {
                path: "/qualityCourse/NewsDetail",
                name: "qualityCourseNewsDetail",
                component: () => import("../components/qualityCourse/NewsDetail.vue"),
                meta: {
                    title: "新闻中心",
                },
            },
            {
                path: "/qualityCourse/NewsDetailOne",
                name: "qualityCourseNewsDetailOne",
                component: () => import("../components/qualityCourse/NewsDetailOne.vue"),
                meta: {
                    title: "新闻中心",
                },
            },
            {
                path: "/qualityCourse/NewsDetailTow",
                name: "qualityCourseNewsDetailTow",
                component: () => import("../components/qualityCourse/NewsDetailTow.vue"),
                meta: {
                    title: "新闻中心",
                },
            },
            {
                path: "/qualityCourse/NewsDetailThree",
                name: "qualityCourseNewsDetailThree",
                component: () => import("../components/qualityCourse/NewsDetailThree.vue"),
                meta: {
                    title: "新闻中心",
                },
            },
        ],
    },
    {
        path: "/login",
        component: loginLayout,
        children: [
            {
                path: "/user/login",
                name: "studentLogin",
                component: () => import("../views/qualityCourse/Login.vue"),
                meta: {
                    title: "云平台--学生登录",
                },
            },
        ],
    },
    {
        path: "/teacherLogin",
        component: loginLayout,
        children: [
            {
                path: "/user/teacherLogin",
                name: "teacherLogin",
                component: () => import("../views/qualityCourse/teacherLogin.vue"),
                meta: {
                    title: "云平台--教师登录",
                },
            },
        ],
    },
    {
        path: "/myclass",
        component: layoutContent,
        children: [
            {
                path: "/",
                name: "myClass",
                component: () => import("../views/student/MyClassIndex.vue"),
                meta: {
                    title: "教师-我的班级主页",
                },
            },
            {
                path: "/myclass/detail",
                name: "myClass",
                component: () => import("../views/student/Myclass.vue"),
                meta: {
                    title: "我的班级",
                },
            },
            {
                path: "/teacherClass/detail",
                name: "myClass",
                component: () => import("../views/student/TeacherClass.vue"),
                meta: {
                    title: "我的班级",
                },
            },
            {
                path: "/teacherClass/student/detail",
                name: "myClass",
                component: () => import("../views/student/StudentDetail.vue"),
                meta: {
                    title: "查看学生",
                },
            },
            {
                path: "/teacherClass/practicalList",
                name: "myClass",
                component: () => import("../views/student/practicalList.vue"),
                meta: {
                    title: "实训列表",
                },
            },
            {
                path: "/teacherClass/practicalDetail",
                name: "myClass",
                component: () => import("../views/student/practicalDetail.vue"),
                meta: {
                    title: "实训详情",
                },
            },
            {
                path: "/teacherClass/scoreBreakdown",
                name: "teacherClassScoreBreakdown",
                component: () => import("../components/qualityCourse/ScoreBreakdown.vue"),
                meta: {
                    title: "得分明细",
                },
            },
            {
                path: "/teacherClass/discussList",
                name: "myClass",
                component: () => import("../views/student/discussList.vue"),
                meta: {
                    title: "讨论列表",
                },
            },
            {
                path: "/teacherClass/discussDetail",
                name: "myClass",
                component: () => import("../views/student/DiscussDetail.vue"),
                meta: {
                    title: "讨论详情",
                },
            },
            {
                path: "/teacherClass/quizList",
                name: "myClass",
                component: () => import("../views/student/QuizList.vue"),
                meta: {
                    title: `教师${config.quizName}列表`,
                },
            },
            {
                path: "/teacherClass/studentQuizList",
                name: "myClass",
                component: () => import("../views/student/StudentQuizList.vue"),
                meta: {
                    title: `学生${config.quizName}列表`,
                },
            },
            {
                path: "/teacherClass/quizApproved",
                name: "myClass",
                component: () => import("../views/student/QuizApproved.vue"),
                meta: {
                    title: "已批阅",
                },
            },
            {
                path: "/teacherClass/quizUnApproved",
                name: "myClass",
                component: () => import("../views/student/QuizUnApproved.vue"),
                meta: {
                    title: "未批阅",
                },
            },
            {
                path: "/teacherClass/quizUnCommitted",
                name: "myClass",
                component: () => import("../views/student/QuizUnCommitted.vue"),
                meta: {
                    title: "未提交",
                },
            },
            {
                path: "/teacherClass/approvedDetail",
                name: "myClass",
                component: () => import("../views/student/ApprovedDetail.vue"),
                meta: {
                    title: "问答题未批阅详情",
                },
            },
            {
                path: "/teacherClass/allApprovedDetail",
                name: "myClass",
                component: () => import("../views/student/AllApprovedDetail.vue"),
                meta: {
                    title: "批阅详情",
                },
            },
        ],
    },
    {
        path: "/learningCenter",
        component: qualityCourseLayout,
        children: [
            {
                path: "/qualityCourse/learningCenter",
                name: "qualityCourseLearningCenter",
                component: () => import("../components/qualityCourse/learningCenter.vue"),
                meta: {
                    title: "学习中心",
                },
            },
            {
                path: "/learning/practicalDetail",
                name: "qualityCourseLearningCenter",
                component: () => import("../views/student/practicalDetail.vue"),
                meta: {
                    title: "实训详情",
                },
            },
            {
                path: "/learning/allApprovedDetail",
                name: "qualityCourseLearningCenter",
                component: () => import("../views/qualityCourse/AllApprovedDetail.vue"),
                meta: {
                    title: "批阅详情",
                },
            },
            {
                path: "/qualityCourse/analysisManagementCenter",
                name: "qualityCourseAnalysisManagementCenter",
                component: () => import("../components/qualityCourse/analysisManagementCenter.vue"),
                meta: {
                    title: "学习分析管理",
                },
            },
            {
                path: "/analysis/practicalDetail",
                name: "qualityCourseAnalysisManagementCenter",
                component: () => import("../views/student/practicalDetail.vue"),
                meta: {
                    title: "实训详情",
                },
            },
            {
                path: "/analysis/allApprovedDetail",
                name: "qualityCourseAnalysisManagementCenter",
                component: () => import("../views/qualityCourse/ApprovedDetail.vue"),
                meta: {
                    title: "批阅详情",
                },
            },
            {
                path: "/qualityCourse/applicationCenter",
                name: "qualityCourseApplicationCenter",
                component: () => import("../components/qualityCourse/applicationCenter.vue"),
                meta: {
                    title: "应用中心",
                },
            },
            {
                path: "/qualityCourse/heroesLeaderboard",
                name: "qualityCourseHeroesLeaderboard",
                component: () => import("../components/qualityCourse/heroesLeaderboard.vue"),
                meta: {
                    title: "英雄榜",
                },
            },
            {
                path: "/qualityCourse/student/dataEvaluationIndex",
                name: "studentDataEvaluationIndex",
                component: () => import("../components/Student/dataEvaluation/index.vue"),
                redirect: "/qualityCourse/student/dataEvaluationIndex/evaluation",
                meta: {
                    title: "综合数据评价",
                },
                children: [
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/evaluation",
                        name: "studentDataEvaluation",
                        component: () => import("../components/teacherCourse/dataEvaluation/dataEvaluation.vue"),
                        meta: {
                            title: "综合数据评价",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/literacy",
                        name: "studentDataLiteracy",
                        component: () => import("../components/Student/dataEvaluation/LiteracyDetail.vue"),
                        meta: {
                            title: "素养考核",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/training",
                        name: "studentDataTraining",
                        component: () => import("../components/Student/dataEvaluation/TrainingDetail.vue"),
                        meta: {
                            title: "技能考核",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/trainingDetail",
                        name: "studentDataTrainingDetail",
                        component: () => import("../components/Student/dataEvaluation/TrainRankingDetail.vue"),
                        meta: {
                            title: "技能考核详情",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/attitude",
                        name: "studentDataAttitude",
                        component: () => import("../components/Student/dataEvaluation/AttitudeDetail.vue"),
                        meta: {
                            title: "态度考核",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/exam",
                        name: "studentDataExam",
                        component: () => import("../components/Student/dataEvaluation/ExamResult.vue"),
                        meta: {
                            title: "考试成绩",
                        },
                    },
                    {
                        path: "/qualityCourse/student/dataEvaluationIndex/knowledge",
                        name: "studentDataKnowledge",
                        component: () => import("../components/Student/dataEvaluation/KnowledgeDetail.vue"),
                        meta: {
                            title: "知识考核",
                        },
                    },
                ],
            },
            {
                path: "/qualityCourse/teacher/dataEvaluationIndex",
                name: "dataEvaluationIndex",
                component: () => import("../components/teacherCourse/dataEvaluation/index.vue"),
                redirect: "/qualityCourse/teacher/dataEvaluationIndex/evaluation",
                meta: {
                    title: "综合数据评价",
                },
                children: [
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/evaluation",
                        name: "dataEvaluation",
                        component: () => import("../components/teacherCourse/dataEvaluation/dataEvaluation.vue"),
                        meta: {
                            title: "综合数据评价",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/literacy",
                        name: "dataLiteracy",
                        component: () => import("../components/teacherCourse/dataEvaluation/LiteracyRanking.vue"),
                        meta: {
                            title: "素养考核",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/literacyDetail",
                        name: "dataLiteracyDetail",
                        component: () => import("../components/teacherCourse/dataEvaluation/LiteracyRankingDetail.vue"),
                        meta: {
                            title: "素养考核详情",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/training",
                        name: "dataTraining",
                        component: () => import("../components/teacherCourse/dataEvaluation/TrainRanking.vue"),
                        meta: {
                            title: "技能考核",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/trainingDetail",
                        name: "dataTrainingDetail",
                        component: () => import("../components/teacherCourse/dataEvaluation/TrainRankingDetail.vue"),
                        meta: {
                            title: "技能考核详情",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/attitude",
                        name: "dataAttitude",
                        component: () => import("../components/teacherCourse/dataEvaluation/AttitudeRanking.vue"),
                        meta: {
                            title: "态度考核",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/attitudeDetail",
                        name: "dataAttitudeDetail",
                        component: () => import("../components/teacherCourse/dataEvaluation/AttitudeRankingDetail.vue"),
                        meta: {
                            title: "态度考核详情",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/knowledge",
                        name: "dataknowledge",
                        component: () => import("../components/teacherCourse/dataEvaluation/KnowledgeRanking.vue"),
                        meta: {
                            title: "知识考核",
                        },
                    },
                    {
                        path: "/qualityCourse/teacher/dataEvaluationIndex/exam",
                        name: "dataExamResult",
                        component: () => import("../components/teacherCourse/dataEvaluation/ExamResult.vue"),
                        meta: {
                            title: "考试成绩",
                        },
                    },
                ],
            },
            {
                path: "/qualityCourse/IndividualCenter",
                name: "qualityCourseIndividualCenter",
                component: () => import("../views/qualityCourse/IndividualCenter.vue"),
                meta: {
                    title: "个人中心",
                },
            },
            {
                path: "/qualityCourse/defaultPage",
                name: "qualityDefaultPage",
                component: () => import("../components/qualityCourse/defaultPage.vue"),
                meta: {
                    title: "加入班级",
                },
            },
        ],
    },
    {
        path: "/Training/Detial",
        component: () => import("../layout/training/Training.vue"),
        meta: {
            title: "实训详情",
        },
        children:[
            {
                path: "/training",
                component: () => import("../layout/training/index.vue"),
                meta: {
                    title: "实训中心",
                },
                children: [
                    {
                        path: "/training/hotVideo",
                        component: () => import("../views/training/HotVideo.vue"),
                        meta: {
                            title: "视频榜单",
                        },
                    },
                    {
                        path: "/training/hotVideoDetail",
                        component: () => import("../views/training/HotVideoDetail.vue"),
                        meta: {
                            title: "视频详情",
                        },
                    },
                    {
                        path: "/training/dsVideo",
                        component: () => import("../views/training/DsVideoRank.vue"),
                        meta: {
                            title: "带货短视频",
                        },
                    },
                    {
                        path: "/training/dsVideoDetail",
                        component: () => import("../views/training/DsVideoDetail.vue"),
                        meta: {
                            title: "视频详情",
                        },
                    },
                ],
            },
            {
                path: "/training/company",
                component: () => import("../views/training/company-analysis/Index.vue"),
                name: "CompanyAnalysis",
                // redirect: "/training/company/general",
                meta: {
                    title: "企业数据分析",
                },
                children: [
                    {
                        path: "/training/company/general",
                        name: "GeneralOverview",
                        component: () => import("../views/training/company-analysis/GeneralOverview.vue"),
                        meta: {
                            title: "综合概览",
                            routerId: 1,
                        },
                    },
                    {
                        path: "/training/company/scene",
                        name: "sceneOverview",
                        component: () => import("@/views/training/scene/Index.vue"),
                        meta: {
                            title: "场景运营数据",
                            routerId: 2,
                        },
                    },
                    {
                        path: "/training/company/fan",
                        name: "FanData",
                        component: () => import("../views/training/company-analysis/FanData.vue"),
                        meta: {
                            title: "粉丝数据",
                            routerId: 3,
                        },
                    },
                    {
                        path: "/training/OperatingData",
                        name:"OperatingData",
                        component: () => import("../views/training/company-analysis/OperatingData.vue"),
                        meta: {
                            title: "经营数据",
                            routerId: 4,
                        },
                    }, {
                        path: "/training/UserData",
                        name:"UserData",
                        component: () => import("../views/training/company-analysis/UserData.vue"),
                        meta: {
                            title: "用户数据",
                            routerId: 5,
                        },
                    },
                ],
            },
            {
                path: "/training/douIndex",
                component: () => import("../views/training/dou/Index.vue"),
                name: "DouIndex",
                redirect: "/training/dou/hot",
                meta: {
                    title: "Dou+投放数据提升",
                },
                children: [
                    {
                        path: "/training/dou/hot",
                        component: () => import("../views/training/dou/HotVideoData.vue"),
                        name: "DouHotVideoData",
                        meta: {
                            title: "上热门",
                            headerLabel: "DOU+上热门",
                            prev: false,
                            isHeader: true,
                            isFooter: true,
                        },
                    },
                    {
                        path: "/training/dou/delivery",
                        component: () => import("../views/training/dou/DeliveryManagement.vue"),
                        name: "DouDeliveryManagement",
                        meta: {
                            title: "投放管理",
                            headerLabel: "DOU+上热门",
                            prev: false,
                            isHeader: true,
                            isFooter: true,
                        },
                    },
                    {
                        path: "/training/dou/delivery/detail",
                        component: () => import("../views/training/dou/DeliveryDetail.vue"),
                        name: "DouDeliveryDetail",
                        meta: {
                            title: "投放详情",
                            headerLabel: "订单详情",
                            prev: true,
                            isHeader: true,
                            isFooter: false,
                        },
                    },
                    {
                        path: "/training/dou/myData",
                        component: () => import("../views/training/dou/MyDouData.vue"),
                        name: "DouMyData",
                        meta: {
                            title: "我的DOU+",
                            isHeader: false,
                            isFooter: true,
                        },
                    },
                ],
            },
            {
                path: "/training/accountDataAnalysis",
                component: () => import("../views/training/accountDataAnalysis.vue"),
                redirect: "/training/accountDataCenter",
                meta: {
                    title: "账号数据分析",
                },
                children: [
                    {
                        path: "/training/accountDataCenter",
                        component: () => import("../views/training/dataCenter/accountDataCenter.vue"),
                        meta: {
                            title: "数据中心",
                        },
                        redirect: "/training/generalView",
                        children: [
                            {
                                path: "/training/generalView",
                                name: "generalView",
                                component: () => import("../components/training/generalView.vue"),
                                meta: {
                                    title: "数据总览",
                                },
                            },
                            {
                                path: "/training/dataPanorama",
                                name: "dataPanorama",
                                component: () => import("../components/training/dataPanorama.vue"),
                                meta: {
                                    title: "作品分析",
                                },
                            },
                            {
                                path: "/training/fansData",
                                name: "fansData",
                                component: () => import("../components/training/fansData.vue"),
                                meta: {
                                    title: "粉丝分析",
                                },
                            },
                            {
                                path: "/training/incomeData",
                                name: "incomeData",
                                component: () => import("../components/training/incomeData.vue"),
                                meta: {
                                    title: "收入分析",
                                },
                            },
                        ],
                    },
                    {
                        path: "/training/workDataDetails",
                        component: () => import("../views/training/dataCenter/workDataDetial.vue"),
                        meta: {
                            title: "作品数据分析详情",
                        },
                    },
                ],
        },
    ]
    },
    

   
    {
        path: "/training/preview",
        component: () => import("../views/training/Preview.vue"),
        meta: {
            title: "文件预览",
        },
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: routes.concat(teachRoutes),
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;
